"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OtherCustomersSection = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _useEndConsumers = require("../../api/useEndConsumers");
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _logger = require("../../logger");
var _types = require("../../types");
var _FormattedMessage = require("../FormattedMessage");
var _SelectField = require("../SelectField");
var _FormTextField = require("./FormTextField");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-no-bind -- x */

const OtherCustomersSection = ({
  selected,
  value,
  onChange
}) => {
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const {
    customerType: customerTypeLimitation
  } = (0, _react.useContext)(_contexts.wizardContext);
  const {
    control,
    setValue
  } = (0, _reactHookForm.useFormContext)();
  const {
    field: existingCustomerIdField
  } = (0, _reactHookForm.useController)({
    name: 'existingCustomerId',
    control
  });
  const existingCustomerId = (0, _reactHookForm.useWatch)({
    name: 'existingCustomerId',
    control
  });
  const {
    data: endConsumersData,
    error,
    isLoading
  } = (0, _useEndConsumers.useEndConsumers)();
  (0, _logger.logDebug)('OtherCustomersSection isLoading: ', isLoading, ' | endConsumersData: ', endConsumersData, ' | error: ', error);
  (0, _react.useEffect)(() => {
    // Reset the existingCustomerId form value when the component is mounted
    setValue('existingCustomerId', null);
  }, [setValue]);
  const selectNewCustomer = (0, _react.useCallback)(() => {
    setValue('existingCustomerId', undefined);
    setValue('customerFirstName', undefined);
    setValue('customerSurname', undefined);
  }, [setValue]);
  if (customerTypeLimitation === _types.EWizardCustomerType.OnlyForMe) {
    return null;
  }
  if (isLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OtherCustomersSectionLoader, {
      animation: "wave"
    });
  }
  const mapEndConsumers = endConsumersData?.collection.map(consumer => {
    const consumerName = `${consumer.firstName ?? ''} ${consumer.lastName ?? ''}`.trim();
    const consumerId = consumer.endConsumerId;
    return {
      Id: consumerId,
      Text: consumerName
    };
  }) ?? [];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.ToggleCard, {
    checked: selected,
    value: value,
    name: "consultant-option",
    type: "radio",
    id: "existing-client",
    onChange: onChange,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OtherSelectedBoldTypography, {
      ownerState: {
        selected
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "customer"
      })
    }), selected && mapEndConsumers.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectField.SelectField, {
      displayEmpty: true,
      id: "existingCustomerId",
      items: mapEndConsumers,
      placeholder: formatMessage('selectCustomer'),
      value: existingCustomerId,
      onChange: e => {
        existingCustomerIdField.onChange(e);
        setValue('existingCustomerId', e.target.value);
        setValue('customerFirstName', '');
        setValue('customerSurname', '');
      }
    }) : null, ' ', selected && existingCustomerId !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SelectNewCustomer, {
      tabIndex: 0,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        variant: "outlined",
        color: "default",
        size: "medium",
        onClick: selectNewCustomer,
        onKeyDown: selectNewCustomer,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Add, {
          fontSize: "inherit"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SelectNewCustomerLabel, {
        onClick: selectNewCustomer,
        onKeyDown: selectNewCustomer,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "newCustomer"
        })
      })]
    }) : null, selected && existingCustomerId === undefined ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.NewCustomer, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormTextField.FormTextField, {
        required: true,
        id: "customerFirstName",
        label: formatMessage('name')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormTextField.FormTextField, {
        required: true,
        id: "customerSurname",
        label: formatMessage('surname')
      })]
    }) : null]
  });
};
exports.OtherCustomersSection = OtherCustomersSection;
